module.exports = __webpack_public_path__ + "static/img/slide6_ban.c7cc023.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/slide6_ban.png
// module id = D67J
// module chunks = 1